import { Cell } from "../Cell";
import { ApplicantOrInvitee } from "../../types";
import { ApplicationStatusBadge } from "shared/app/ApplicationStatusBadge";
import { Invitee } from "shared/types";
import { getApplicantStatus } from "utils/get-applicant-status";

interface ApplicationStartedCellProps {
  applicant: ApplicantOrInvitee;
  pendingMagicLink?: Invitee;
}

export const ApplicationStatusCell = ({
  applicant,
  pendingMagicLink
}: ApplicationStartedCellProps) => {
  const effectiveStatus = getApplicantStatus({
    applicant,
    pendingMagicLink
  });

  return (
    <Cell isFirst isDataCell className="text-content-400">
      <ApplicationStatusBadge
        type="applicant"
        status={effectiveStatus}
        isAutoCanceled={
          "canceled_by_auto_cancel" in applicant &&
          !!applicant.canceled_by_auto_cancel
        }
      />
    </Cell>
  );
};
